import { fork } from 'redux-saga/effects';

import { routinePromiseWatcherSaga } from 'redux-saga-routines';

import {
  watchLoginSaga,
  watchFetchProfileSaga,
  watchLogoutSaga,
  // watchResetPasswordSaga,
  watchRegisterSaga
} from './authentication';
import {
  watchFetchCustomersSaga,
  watchFetchCustomerSaga,
  watchSaveCustomerSaga,
  watchRemoveCustomerSaga,
  watchSaveCustomerAddressSaga,
  // watchSaveCustomerLogoSaga,
} from './customers';
import {
  watchFetchJobsSaga,
  watchFetchJobSaga,
  watchSaveJobSaga,
  watchSaveJobResourcesSaga,
  watchRemoveJobSaga,
} from './jobs';
import {
  watchFetchTasksSaga, watchFetchTaskSaga,
  watchUploadTasksSaga, watchSaveTaskAssignmentsSaga,
  watchEditTaskSaga, watchRemoveTasksSaga, watchSendTaskSmsSaga, watchSendTaskEmailSaga,
} from './tasks';
import { watchFetchTaskFileConfigsSaga } from './taskfileconfigs';
import {
  watchFetchEmployeesSaga,
  watchFetchEmployeeSaga,
  watchSaveEmployeeSaga,
  watchRemoveEmployeeSaga,
} from './employees';
import {
  watchFetchJobProfilesSaga,
  watchFetchJobProfileSaga,
  watchSaveJobProfileSaga,
  watchRemoveJobProfileSaga,
} from './jobprofiles';
import {
  watchFetchTaskProfilesSaga,
  watchFetchTaskProfileSaga,
  watchSaveTaskProfileSaga,
  watchRemoveTaskProfileSaga
} from './taskprofiles';
import { watchFetchRolesSaga, watchSaveRoleSaga, watchRemoveRoleSaga } from './roles';
import { watchFetchStaticSaga } from './static';
import { watchFetchItemTypesSaga } from './itemtypes';
import { watchFetchLabelFormatsSaga } from './labelformats';
import { watchFetchRecentActivitySaga } from './activity';
import { watchFetchExceptionsSaga, watchResolveExceptionSaga } from './exceptions';
// import {
//   watchConfirmPasswordResetLinkSaga, watchEmailVerificationSaga,
//   watchConfirmPasswordResetSaga,
// } from './firebase';
import { watchFetchPrintersSaga, watchSavePrinterSaga, watchRemovePrinterSaga } from './printers';
import {
  watchFetchAccounts,
  watchAddAccountSaga,
  watchUpgradeAccount,
  watchGetTaskCount,
  watchFetchInvoices,
  watchGetPaymentSource,
  watchUpdatePaymentSource,
  watchCancelAccount,
} from './accounts';
import { watchFetchReportSaga } from './reports';

export default function* rootSaga() {
  yield fork(watchLoginSaga);
  yield fork(watchFetchProfileSaga);
  yield fork(watchLogoutSaga);

  yield fork(watchFetchAccounts);
  yield fork(watchAddAccountSaga);

  // yield fork(watchResetPasswordSaga);
  yield fork(watchRegisterSaga);

  yield fork(watchFetchCustomersSaga);
  yield fork(watchFetchCustomerSaga);
  yield fork(watchSaveCustomerSaga);
  yield fork(watchRemoveCustomerSaga);
  yield fork(watchSaveCustomerAddressSaga);
  // yield fork(watchSaveCustomerLogoSaga);

  yield fork(watchFetchJobsSaga);
  yield fork(watchFetchJobSaga);
  yield fork(watchSaveJobSaga);
  yield fork(watchSaveJobResourcesSaga);
  yield fork(watchRemoveJobSaga);

  yield fork(watchFetchExceptionsSaga);
  yield fork(watchResolveExceptionSaga);

  yield fork(watchFetchEmployeesSaga);
  yield fork(watchFetchEmployeeSaga);
  yield fork(watchSaveEmployeeSaga);
  yield fork(watchRemoveEmployeeSaga);

  yield fork(watchFetchJobProfilesSaga);
  yield fork(watchFetchJobProfileSaga);
  yield fork(watchSaveJobProfileSaga);
  // yield fork(watchSaveJobProfileStageSaga);
  yield fork(watchRemoveJobProfileSaga);
  // yield fork(watchRemoveJobProfileStageSaga);

  yield fork(watchFetchTaskProfilesSaga);
  yield fork(watchFetchTaskProfileSaga);
  yield fork(watchSaveTaskProfileSaga);
  yield fork(watchRemoveTaskProfileSaga);

  yield fork(watchFetchTasksSaga);
  yield fork(watchFetchTaskSaga);
  yield fork(watchRemoveTasksSaga);

  yield fork(watchSendTaskSmsSaga);
  yield fork(watchSendTaskEmailSaga);

  yield fork(watchFetchTaskFileConfigsSaga);

  yield fork(watchFetchRolesSaga);
  yield fork(watchSaveRoleSaga);
  yield fork(watchRemoveRoleSaga);

  yield fork(watchFetchStaticSaga);
  yield fork(watchFetchItemTypesSaga);

  yield fork(watchUploadTasksSaga);
  yield fork(watchSaveTaskAssignmentsSaga);

  // yield fork(watchRegisterUserSaga);
  // yield fork(watchRegistrationSuccessSaga);
  // yield fork(watchChangeUserPassword);
  // yield fork(watchFetchUserSaga);

  yield fork(watchFetchLabelFormatsSaga);

  // yield fork(watchConfirmPasswordResetLinkSaga);
  // yield fork(watchConfirmPasswordResetSaga);
  // yield fork(watchEmailVerificationSaga);

  yield fork(watchFetchRecentActivitySaga);
  yield fork(watchEditTaskSaga);

  yield fork(watchFetchPrintersSaga);
  yield fork(watchSavePrinterSaga);
  yield fork(watchRemovePrinterSaga);

  yield fork(watchUpgradeAccount);
  yield fork(watchGetTaskCount);
  yield fork(watchGetPaymentSource);
  yield fork(watchUpdatePaymentSource);
  yield fork(watchFetchInvoices);
  yield fork(watchCancelAccount);

  yield fork(watchFetchReportSaga);

  // yield fork(routinesWatcherSaga); //TODO auth0 fix

  yield fork(routinePromiseWatcherSaga);
};



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js